// extracted by mini-css-extract-plugin
module.exports = {"Spectacle":"spectacle_Spectacle__3iBK4","row":"spectacle_row__1ffVq"};